import type { SecondLineResultCount } from '@risksmart-app/trpc/src/types';
import type { GetOversightAssessmentResultCountQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetOversightAssessmentResultCountDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

export const useGetOversightAssessmentResultCount = createQueryHook<
  Record<string, never>,
  SecondLineResultCount,
  GetOversightAssessmentResultCountQuery
>({
  trpcQueryOptions: (trpc) =>
    trpc.frontend.assessment.complianceMonitoringAssessmentResultCount.queryOptions(),
  // Map each per-table count back onto its GraphQL aggregate root. ConnectedCount
  // sums the four; the factory surfaces undefined while loading, so genuine
  // zeros are preserved (no `?? 0` masking).
  mapTrpcDataToGraphQL: (data) => ({
    risk_controlled_oversight_result_aggregate: {
      aggregate: { count: data.risk_controlled_second_line_result },
    },
    risk_uncontrolled_oversight_result_aggregate: {
      aggregate: { count: data.risk_uncontrolled_second_line_result },
    },
    document_oversight_result_aggregate: {
      aggregate: { count: data.document_second_line_result },
    },
    obligation_oversight_result_aggregate: {
      aggregate: { count: data.obligation_second_line_result },
    },
  }),
  graphqlDocument: GetOversightAssessmentResultCountDocument,
});
